import React from 'react';
import { useNavigate } from 'react-router-dom';

function DashBoardBoxItems({
  backcolor,
  textcolor,
  title,
  Data,
  navigatePath,
  onClickFunction,
  onClickParams,
  disabled = false,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!disabled) {
      if (onClickFunction) onClickFunction(...onClickParams);
      navigate(navigatePath);
    }
  };

  return (
    <div className="col-sm-3 d-flex"> {/* Make column a flex container */}
      <div
        className="card"
        style={{
          background: backcolor,
          color: textcolor,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flexGrow: 1,   // Make card take full height of column
          padding: '20px',
        }}
      >
        <div>
          <h5 className="card-title text-center">{title}</h5>
        </div>

        <div className="text-center">
          <button
            onClick={handleClick}
            style={{
              background: "#fff",
              color: backcolor,
              fontSize: '24px',
              fontWeight: 'bold',
              cursor: disabled ? 'not-allowed' : 'pointer',
              border: 'none',
             // padding: '10px 20px',
              borderRadius: '10px',
              width: '60%',
            }}
            disabled={disabled}
          >
            {Data}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DashBoardBoxItems;
